import * as yup from 'yup'

const EmailValidator = yup.object().shape({
  email: yup.string().email().required(),
})

export default EmailValidator
